const t = "data:image/svg+xml,%3csvg%20width='40'%20height='40'%20viewBox='0%200%2040%2040'%20fill='none'%20xmlns='http://www.w3.org/2000/svg'%3e%3cpath%20d='M30.7002%2040V9.3L40.0002%200V40H30.7002Z'%20fill='%23E30613'/%3e%3cpath%20d='M0%2039.9998L30.7%209.2998V39.9998H0Z'%20fill='%23C6C6C6'/%3e%3cpath%20d='M0%2039.9998V9.2998H30.7L0%2039.9998Z'%20fill='%23008ECF'/%3e%3cpath%20d='M0%209.3V0H40L30.7%209.3H0Z'%20fill='%23AE0F0A'/%3e%3c/svg%3e";
export {
  t as default
};
